import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class NotifService {

  private notificationSubject = new Subject<any[]>();
  notification$ = this.notificationSubject.asObservable();
  private notifications: any[] = [];

  constructor(private messageService: MessageService) {}

  updateNotifications(notifications: any[]) {
    this.notificationSubject.next(notifications);
    // Also show via toast
    notifications.forEach(n => {
      this.messageService.add(n);
    });
  }

  addNotification(notification: any) {
    this.notifications.push(...notification);
    this.notificationSubject.next(this.notifications);
    // Also show via toast
    notification.forEach((n: any) => {
      this.messageService.add(n);
    });
  }

  newAppVersion: Subject<string> = new Subject<string>();

  displayNewVersion(serverVersion: string){
    this.newAppVersion.next(serverVersion);
  }
}
